import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  employeeMonitorsLength: 0,
  employeeMonitors: [],
  employeeMonitor: {},
  employeeMonitorError: "",
  formError: "",
};

export default function EmployeeMonitorReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_EMPLOYEE_MONITOR:
      return { ...state, loading: action.payload };
    case actions.LOADING_EMPLOYEE_MONITOR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_EMPLOYEE_MONITOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_EMPLOYEE_MONITOR:
      return {
        ...state,
        employeeMonitors: action.payload.employeeMonitors,
        employeeMonitorsLength: action.payload.employeeMonitorsLength,
      };
    case actions.GET_EMPLOYEE_MONITOR_BY_ID:
      return {
        ...state, employeeMonitor: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.EMPLOYEE_MONITOR_FAIL:
      return { ...state, employeeMonitorError: action.payload };
    default:
      return state;
  }
}
